<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="72"></v-progress-circular>
    </v-overlay>
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="calories"
      class="elevation-1"
    >
      <template #top>
        <v-row class="justify-center">
          <v-col cols="6">
            <v-text-field
              v-model="searchInput"
              placeholder="Suchen"
              class="mx-2"
              outlined
              dense
              hide-details
              clearable
              @keyup.enter.native="search"
            >
              <template #append-outer>
                <v-btn icon class="align-self-center" @click="search">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template></v-text-field
            >
          </v-col>
        </v-row>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="justify-center"
              >Wollen Sie wirklich stornieren ?</v-card-title
            >
            <v-divider />
            <v-card-actions>
              <v-btn color="secondary" @click="closeDelete">Abbrechen</v-btn>
              <v-spacer />
              <v-btn color="error" @click="deleteItemConfirm">Ja</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogError" max-width="500px">
          <v-card>
            <v-card-title class="justify-center error white--text"
              >Error</v-card-title
            >
            <v-divider />
            <v-card-text class="pt-4">
              <h2>{{ apiError }}</h2>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="closeError">OK</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn icon @click="deleteItem(item)">
          <v-icon color="error">
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template #no-data>
        Kein Inhalt, Bitte die Suche benutzen
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { OneProcessService } from '@/services'
export default {
  data: () => ({
    overlay: false,
    dialog: false,
    dialogDelete: false,
    dialogError: false,
    apiError: '',
    headers: [
      {
        text: 'Kundentext',
        align: 'start',
        value: 'cfgCustomerText'
      },
      { text: 'Jobnummer', value: 'cfgJobNumber' },
      { text: 'Dateiname', value: 'fileName' },
      { text: 'Status', value: 'status' },
      { text: 'Aktion', align: 'end', value: 'actions', sortable: false }
    ],
    items: [],
    itemToDelete: {},
    searchInput: ''
  }),
  methods: {
    search() {
      this.overlay = true
      OneProcessService.getJobs({ searchString: this.searchInput })
        .then(response => {
          this.items = response.jobs
        })
        .catch(e => {
          this.showError(e)
        })
        .finally(() => {
          this.overlay = false
        })
    },
    deleteItem(item) {
      this.itemToDelete = item
      this.dialogDelete = true
    },
    deleteItemConfirm() {
      this.overlay = true
      OneProcessService.deleteJob(this.itemToDelete.id)
        .then(() => {
          this.items.splice(this.items.indexOf(this.itemToDelete), 1)
        })
        .catch(e => {
          this.showError(e)
        })
        .finally(() => {
          this.overlay = false
        })
      this.closeDelete()
    },
    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.itemToDelete = {}
      })
    },
    showError(error) {
      this.apiError = error
      this.dialogError = true
    },
    closeError() {
      this.apiError = ''
      this.dialogError = false
    }
  }
}
</script>

<style lang="scss">
.v-input__append-outer {
  margin: 0 !important;
}
</style>
